import ndjsonStream from 'can-ndjson-stream';

const API_BASE_URL = 'https://monitor.piosphere.ai';

export const getMetricsByNodeId = async (nodeId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/metrics?node_id=${nodeId}`);
    
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    
    const streamReader = await ndjsonStream(response.body).getReader();
    
    return { 
      streamReader,
      error: null 
    };
  } catch (error) {
    console.error('Error setting up metrics stream:', error);
    return { 
      streamReader: null, 
      error: error.message 
    };
  }
};

export const getAllMetrics = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/metrics/all`);
    
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    
    const streamReader = await ndjsonStream(response.body).getReader();
    
    return { 
      streamReader,
      error: null 
    };
  } catch (error) {
    console.error('Error setting up all metrics stream:', error);
    return { 
      streamReader: null, 
      error: error.message 
    };
  }
};

